module.exports = __webpack_public_path__ + "static/tim-ferriss-1f5894aadabb1f3cb34eb4d4dd26d551.jpg";